// extracted by mini-css-extract-plugin
export default {"headInfo":"header_headInfo__JAlvC","headerBackground":"header_headerBackground__V9roM"};